import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { environment } from '@env';

import * as rxjs from 'rxjs';
import * as rxjsOperators from 'rxjs/operators';
import { v4 } from 'uuid';
import { bootstrapApplication } from '@angular/platform-browser';
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { routes } from './app/app.routes';
import { provideEngineCore } from '@core/core.providers';
import { AppComponent } from './app/app.component';

declare global {
  interface Window {
    v4: () => string;
    rxjs: typeof rxjs;
    rxjsOperators: typeof rxjsOperators;
  }
}
window.rxjs = { ...rxjs, operators: rxjsOperators } as any;
window.rxjsOperators = rxjsOperators;
window.v4 = v4;

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
      withPreloading(PreloadAllModules),
    ),
    provideEngineCore(),
  ],
}).catch((err) => console.error(err));
